module.exports = __webpack_public_path__ + "static/23import-5df6cc12aaa9698cfafe9ade9f9ca116.png";